import _regeneratorRuntime from 'babel-runtime/regenerator';

var _this = this;

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin: 0 30px;\n  margin-top: 30px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin: 0 30px;\n  margin-top: 30px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n  font-size: 20px;\n  font-weight: bold;\n  color: ', ';\n'], ['\n  font-family: ', ';\n  font-size: 20px;\n  font-weight: bold;\n  color: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  max-width: 490px;\n  @media screen and (max-width: 575.98px) {\n    min-width: 0px;\n    width: 95%;\n    margin: 10px;\n  }\n  .modal-content {\n    border-radius: 0;\n    border: none;\n  }\n'], ['\n  max-width: 490px;\n  @media screen and (max-width: 575.98px) {\n    min-width: 0px;\n    width: 95%;\n    margin: 10px;\n  }\n  .modal-content {\n    border-radius: 0;\n    border: none;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 0;\n  margin: 30px;\n'], ['\n  padding: 0;\n  margin: 30px;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n'], ['\n  text-align: center;\n']);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { pathOr } from 'ramda';
import { Modal, ModalBody } from 'reactstrap';
import Theme from '../../Theme';
import { InfoIcon, SuccessCheckmarkIcon } from '../Icons';

var TitleBar = styled.header(_templateObject);

export var Title = styled.div(_templateObject2, Theme.fonts.Montserrat, Theme.colors.primary);

var NarrowModal = styled(Modal)(_templateObject3);

var Body = styled(ModalBody)(_templateObject4);

var ModalLoaderText = styled.h6(_templateObject5);

var sleep = function sleep(ms) {
  return new Promise(function (resolve, reject) {
    return setTimeout(resolve, ms);
  });
};
var isComplete = function isComplete(status) {
  return status.includes('Completed');
};

export var ModalCompleteDefault = function ModalCompleteDefault(_ref) {
  var ModalBodyChild = _ref.ModalBodyChild;
  return React.createElement(
    'div',
    { className: 'd-flex flex-column align-items-center' },
    React.createElement(SuccessCheckmarkIcon, null),
    React.createElement(
      ModalLoaderText,
      { className: 'mt-4 mb-1' },
      'Process successfully complete!'
    ),
    ModalBodyChild && React.createElement(ModalBodyChild, null)
  );
};

export var ModalBodyLoader = function ModalBodyLoader(_ref2) {
  var widStatusQuery = _ref2.widStatusQuery,
      wid = _ref2.wid,
      ModalBodyComp = _ref2.ModalBodyComp,
      ModalBodyChild = _ref2.ModalBodyChild;

  var _useState = useState({}),
      response = _useState[0],
      setResponse = _useState[1];

  useEffect(function () {
    var pingStatus = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, widStatus;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (typeof widStatusQuery === 'function') {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.next = 4;
                return widStatusQuery(wid);

              case 4:
                response = _context.sent;

                setResponse(response);

                widStatus = pathOr('', ['data', 'widStatus'], response);

                if (isComplete(widStatus)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 10;
                return sleep(1000);

              case 10:
                return _context.abrupt('return', pingStatus());

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function pingStatus() {
        return _ref3.apply(this, arguments);
      };
    }();

    pingStatus();
  }, []);

  var loading = response.loading,
      error = response.error,
      data = response.data;


  if (loading) return React.createElement(
    ModalLoaderText,
    null,
    'Loading...'
  );
  if (error) return React.createElement(
    ModalLoaderText,
    null,
    'There was an Error with the request.'
  );

  var widStatus = pathOr('', ['widStatus'], data);

  return isComplete(widStatus) ? ModalBodyComp ? React.createElement(ModalBodyComp, null) : React.createElement(ModalCompleteDefault, { ModalBodyChild: ModalBodyChild }) : React.createElement(
    ModalLoaderText,
    null,
    'Loading...'
  );
};

var hasWidValue = function hasWidValue(wid) {
  return !!wid;
};

var WidModal = function WidModal(_ref4) {
  var wid = _ref4.wid,
      widStatusQuery = _ref4.widStatusQuery,
      ModalBodyComp = _ref4.ModalBodyComp,
      ModalBodyChild = _ref4.ModalBodyChild,
      size = _ref4.size,
      title = _ref4.title;
  return React.createElement(
    NarrowModal,
    { isOpen: hasWidValue(wid), size: size, centered: true },
    React.createElement(
      TitleBar,
      null,
      React.createElement(InfoIcon, null),
      React.createElement(
        Title,
        { fontFamily: Theme.fonts.Montserrat },
        title
      )
    ),
    React.createElement(
      Body,
      null,
      React.createElement(ModalBodyLoader, { widStatusQuery: widStatusQuery, wid: wid, ModalBodyComp: ModalBodyComp, ModalBodyChild: ModalBodyChild })
    )
  );
};

WidModal.defaultProps = {
  wid: '',
  size: 'lg',
  title: 'Processing, Please Wait...'
};

export default WidModal;